import {
  ChangeDetectionStrategy,
  Component,
  Input,
  output
} from '@angular/core';
import { ToastMessageOptions } from 'primeng/api';
import { NgClass } from '@angular/common';
import { Message } from 'primeng/message';

/** CSS variable references for severity-specific icon colors */
const SEVERITY_ICON_COLORS: Record<string, string> = {
  info: 'var(--m-primary-color)',
  warn: 'var(--m-orange-300)',
  error: 'var(--m-red-700)',
  success: 'var(--m-green-700)'
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-messages',
  templateUrl: './m-messages.component.html',
  styleUrls: ['./m-messages.component.scss'],
  host: {
    class: 'block'
  },
  imports: [NgClass, Message]
})
export class MMessagesComponent {
  @Input() messages: ToastMessageOptions[] = [];
  @Input() fullScreen = false;
  @Input() closable = true;
  @Input() escape = true;
  @Input() size: 'small' | 'large' | undefined;
  @Input() styleClass = '';

  readonly closeMessage = output<{
    originalEvent: Event;
  }>();

  /** Returns the CSS variable reference for the severity-specific icon color */
  getIconColor(severity: string | undefined): string {
    return severity ? (SEVERITY_ICON_COLORS[severity] ?? 'inherit') : 'inherit';
  }

  handleClose(event: { originalEvent: Event }): void {
    this.closeMessage.emit(event);
  }
}
